import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useImperativeHandle, useState } from 'react';
import axios from "axios";
import { Spin } from "antd";
import { axiosErrorHandler } from "../../../../../swzutils";
import HelpLabel from "../../../components/HelpLabel";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBoxArchive } from '@fortawesome/free-solid-svg-icons/faBoxArchive';
import ValOrDash from "../../../components/ValOrDash";
import { ElapsedMinutesFormat } from "../../../components/FormattersTS";
const AverageDeliveryTimeWidget = (props, exportedRef) => {
    const [loading, setLoading] = useState(false);
    const [averageDeliveryTime, setAverageDeliveryTime] = useState(null);
    useImperativeHandle(exportedRef, () => {
        return {
            refresh
        };
    });
    // useEffect(() => {
    //     refresh()
    // }, []);
    const refresh = () => {
        loadAverageDeliveryTimes();
    };
    const loadAverageDeliveryTimes = () => {
        setLoading(true);
        axios.get(`/admin/v1/dashboard/average-delivery-times/${props.date}`)
            .then(response => {
            setAverageDeliveryTime(response.data);
        })
            .catch(error => {
            setAverageDeliveryTime(null);
            axiosErrorHandler(error);
        })
            .finally(() => {
            setLoading(false);
        });
    };
    return (_jsx(Spin, { spinning: loading, children: _jsxs("div", { className: "widget", children: [_jsx("div", { className: "widget-icon widget-icon-aqua", children: _jsx(FontAwesomeIcon, { icon: faBoxArchive }) }), averageDeliveryTime?.actualAverageDeliveryDurationMinutes
                    ? _jsx("h2", { className: "widget-value", children: _jsx(ElapsedMinutesFormat, { value: averageDeliveryTime.actualAverageDeliveryDurationMinutes }) })
                    : _jsx("h2", { className: "widget-value", children: "\u2014" }), _jsx("p", { children: _jsx(HelpLabel, { title: "Average time per delivery", helpText: _jsx("p", { children: "The actual average delivery time determined in real time. This value if the sum of all time sheeted hours divided by the number of completed deliveries." }) }) }), _jsx("div", { className: "widget-separator" }), averageDeliveryTime?.calculatedAverageDeliveryDurationMinutes
                    ? _jsxs("h2", { className: "widget-value", children: [_jsx(ElapsedMinutesFormat, { value: averageDeliveryTime?.calculatedAverageDeliveryDurationMinutes }), averageDeliveryTime?.avgDistanceKilometres &&
                                _jsxs("span", { className: "small", children: ["\u00A0(avg ", _jsx(ValOrDash, { val: averageDeliveryTime.avgDistanceKilometres }), " Km per delivery)"] })] })
                    : _jsx("h2", { className: "widget-value", children: "\u2014" }), _jsx("p", { children: _jsx(HelpLabel, { title: "Calculated average time per delivery", helpText: _jsx("p", { children: "The average delivery time calculated across all deliveries that have a delivery vehicle assigned to them. Unassigned deliveries and deliveries that have a vehicle assigned however the vehicle is not considered to perform deliveries are excluded.  Deliveries that have a freight unit of measure of HOURS are also excluded." }) }) })] }) }));
};
export default React.forwardRef(AverageDeliveryTimeWidget);
